import React, { useEffect, useRef } from "react";
import mermaid from "mermaid";
mermaid.initialize({ startOnLoad: false });

const Mermaid = ({ chart }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const renderMermaid = async () => {
      if (!chartRef.current) return;

      try {
        const { svg } = await mermaid.render(`mermaid-${Date.now()}`, chart);
        if (isMounted && chartRef.current) {
          chartRef.current.innerHTML = svg;
        }
      } catch (err) {
        console.error("Mermaid render error:", err);
        if (chartRef.current) {
          chartRef.current.innerHTML = `<pre style="color: red;">Invalid Mermaid syntax or render error</pre>`;
        }
      }
    };

    renderMermaid();

    return () => {
      isMounted = false;
    };
  }, [chart]);

  return <div ref={chartRef} />;
};

export default Mermaid;